import { useState } from "react";
import { ArrowLeft, CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import BottomNav from "../components/BottomNav";

const cryptoList = [
  {
    id: "btc",
    name: "Bitcoin",
    symbol: "BTC",
    icon: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png?1696501400",
  },
  {
    id: "eth",
    name: "Ethereum",
    symbol: "ETH",
    icon: "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1696501410",
  },
  {
    id: "usdt",
    name: "Tether",
    symbol: "USDT",
    icon: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1696501661",
  },
  {
    id: "bnb",
    name: "BNB",
    symbol: "BNB",
    icon: "https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png?1696501970",
  },
  {
    id: "sol",
    name: "Solana",
    symbol: "SOL",
    icon: "https://assets.coingecko.com/coins/images/4128/small/solana.png?1696504756",
  },
  {
    id: "xrp",
    name: "XRP",
    symbol: "XRP",
    icon: "https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png?1696501442",
  },
  {
    id: "ltc",
    name: "LTC",
    symbol: "LTC",
    icon: "https://assets.coingecko.com/coins/images/2/standard/litecoin.png?1696501400",
  },
  {
    id: "usdc",
    name: "USDC",
    symbol: "USDC",
    icon: "https://assets.coingecko.com/coins/images/6319/standard/usdc.png?1696506694",
  },
];

export default function FundCryptoPage() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);

  const handleContinue = () => {
    if (!selected) return;
    navigate(`/fund/${selected.id}`);
  };

  return (
    <>
      {/* Page with safe bottom padding */}
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white pt-20 pb-24 px-4">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8">

            {/* Header */}
            <div className="flex items-center mb-8">
              <button
                onClick={() => navigate(-1)}
                className="mr-4 p-2 rounded-full hover:bg-gray-100 transition"
                aria-label="Go back"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <h1 className="text-2xl font-bold text-primary">Fund Your Wallet</h1>
            </div>

            <p className="text-gray-600 mb-8">
              Choose the cryptocurrency you want to deposit. We'll show you a unique address.
            </p>

            {/* Crypto Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8">
              {cryptoList.map((coin) => (
                <button
                  key={coin.id}
                  onClick={() => setSelected(coin)}
                  className={`
                    relative p-6 rounded-xl border-2 transition-all flex flex-col items-center
                    ${selected?.id === coin.id
                      ? "border-primary bg-primary/5 shadow-lg"
                      : "border-gray-200 hover:border-primary/30 hover:bg-gray-50"
                    }
                  `}
                  aria-label={`Select ${coin.name}`}
                >
                  <img
                    src={coin.icon}
                    alt={`${coin.name} logo`}
                    className="w-12 h-12 mb-2 object-contain"
                    loading="lazy"
                  />
                  <div className="font-semibold text-gray-900">{coin.name}</div>
                  <div className="text-sm text-gray-500">{coin.symbol}</div>

                  {selected?.id === coin.id && (
                    <CheckCircle className="absolute top-2 right-2 w-5 h-5 text-primary" />
                  )}
                </button>
              ))}
            </div>

            {/* Continue */}
            <button
              onClick={handleContinue}
              disabled={!selected}
              className={`
                w-full py-3 rounded-xl font-semibold transition-all flex items-center justify-center
                ${selected
                  ? "bg-primary text-white hover:bg-primary/90 shadow-lg"
                  : "bg-gray-200 text-gray-500 cursor-not-allowed"
                }
              `}
            >
              Continue to Deposit Address
            </button>
          </div>
        </div>
      </div>
      {/* Bottom Navigation */}
      <BottomNav />
    </>
  );
}